import React from 'react';
import clsx from 'clsx';

export type ButtonClickEvent = React.MouseEvent<HTMLButtonElement>;

export interface IButton {
  label?: string;

  /**
   * Default: 'button'
   */
  type?: 'button' | 'submit' | 'reset';

  /**
   * Default: 'm'
   */
  size?: 's' | 'm' | 'l';

  /**
   * Default: 'primary'
   */
  theme?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'light'
    | 'dark'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'outline-warning'
    | 'outline-light'
    | 'outline-dark';

  className?: string;

  disabled?: boolean;

  onClick?: (event: ButtonClickEvent) => void;

  children?: any;
}

export function Button({
  label,
  type = 'button',
  size = 'm',
  theme = 'primary',
  className = '',
  disabled = false,
  onClick = () => {},
  children,
}: IButton) {
  return (
    <button
      disabled={disabled}
      type={type || 'button'}
      className={clsx('btn', className, {
        'btn-info': theme === 'primary',
        'btn-secondary': theme === 'secondary',
        'btn-success': theme === 'success',
        'btn-danger': theme === 'danger',
        'btn-warning': theme === 'warning',
        'btn-light': theme === 'light',
        'btn-dark': theme === 'dark',
        'btn-outline-info': theme === 'outline-primary',
        'btn-outline-secondary': theme === 'outline-primary',
        'btn-outline-success': theme === 'outline-success',
        'btn-outline-danger': theme === 'outline-danger',
        'btn-outline-warning': theme === 'outline-warning',
        'btn-outline-light': theme === 'outline-light',
        'btn-outline-dark': theme === 'outline-dark',
        'btn-sm': size === 's',
        'btn-lg': size === 'l',
      })}
      onClick={onClick}
    >
      {label || children}
    </button>
  );
}
